// 文件状态枚举
export enum EStateColor {
  one = 1,
  two,
  three,
  four,
  five,
  six,
  seven
}

// 审核类型枚举
// const 常量枚举, 不能用于计算
export const enum EApprovalType {
  AppInfo = 1,
  AppApprove,
  AppUp,
  AppDown
}

// 可以用于计算, 正反映射取值, EApprovalColor可以当做对象使用
export enum EApprovalColor {
  five = 1,
  two = 2,
  three = 3,
  four = 4
}

export enum EApprovalState {
  Waiting = 1,
  Processing,
  Pass,
  NotPass
}
